import { FC } from 'react';

import clsx from 'clsx';
import { getOnePageCurrentStyleIcon } from 'layouts/OnePagePreviewLayout/helpers/getOnePageCurrentStyleIcon';

import { Button } from 'components/_basic/Button/Button';

import { IOpenStyleSelectorButtonProps } from './types';

import styles from './OpenStyleSelectorButton.module.scss';

export const OpenStyleSelectorButton: FC<IOpenStyleSelectorButtonProps> = ({
  onClick,
  className,
  businessPlanOnePageStyle,
  text,
}) => {
  return (
    <Button
      onClick={onClick}
      variant="text"
      size="medium"
      className={clsx(styles['select-style-button'], className)}
      startIcon={getOnePageCurrentStyleIcon(businessPlanOnePageStyle)}
    >
      {text}
    </Button>
  );
};
